<template>
  <el-card>
      <app-modal-new-project v-if="addNewProject"></app-modal-new-project>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Inicio</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/dashboard/usuarios' }">Usuarios</el-breadcrumb-item>
            <el-breadcrumb-item >{{breadcrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <el-form @submit.native.prevent="save" ref="form" label-position="top" id="user" >
            <el-row type="flex" justify="space-between">
                <el-col :span="11">
                    <el-form-item label="Email">
                        <el-input v-model="form.user"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="Contraseña">
                        <el-input v-model="form.pass"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="space-between">
                <el-col :span="7">
                    <el-form-item label="Nombre">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1"></el-col>
                <el-col :span="5">
                    <el-form-item label="Nivel de acceso">
                        <select class="select" v-model="form.level_id">
                            <option v-for="(l, i) in levels" :key="i" :value="l.id">{{l.name}}</option>
                        </select>
                    </el-form-item>
                </el-col>
                <el-col :span="1"></el-col>                
                <el-col :span="10">
                    <el-form-item label="Proyectos asociados">
                        <el-select v-model="project" multiple placeholder="Select" @change="changueProjectc" @remove-tag="deleteProjectc">
                            <el-option
                                v-for="(item, index) in proyectos"
                                :key="index"
                                :label="item.proyecto"
                                :value="item.id" >
                            </el-option>
                        </el-select>
                        <button type="text" form="a"  @click="addProject()" class="el-button"><span>Añadir nuevo proyecto</span></button>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <br />
                    <button v-if="this.showBottons" type="submit" class="el-button el-button--primary" form="user"><span>{{btn}}</span></button>
                    <el-button v-if="!$route.params.user_id" @click="close()">Cancelar</el-button>
                </el-col>
            </el-row>
        </el-form>
  </el-card>
</template>

<script>
    import sha1 from 'sha1'
	import ApiService from '@/common/api.service'
    import ModalProject from '@/components/Dashboard/Modals/addNewProject'
    export default {
        name: 'usuario',
        components: {
            'app-modal-new-project': ModalProject
        },
        created () {
			this.$root.$on('closeModal', ()=> {
				this.addNewProject = false
				this.getProjects()
			})

            if(this.$route.params.user_id){
                this.breadcrumb = 'Edición usuario'
                this.btn = 'Actualizar'
                this.id = this.$route.params.user_id
                setTimeout(() => {
                    this.getLevels()
                    this.getUser()
                    setTimeout(() => {
                        this.getProject()                    
                    }, 100);
                }, 200);
            }else{
                this.breadcrumb = 'Nuevo usuario'                
                this.getLevels()
            }
            this.getProjects()
            
            this.showBottons = true
            
        },
        data () {
            return {
                id: null,
                btn: 'Crear',
                form: {
                    user: null,
                    pass: null,
                    level_id: 2,
                    name: null
                },
                project: [],
                proyecto: {
                    id: null,
                    proyecto: null
                },
                proyectos: null,
                levels: {},
                passOld: null,
                addNewProject: false,
                proyectoOld: null,
                error: true,
                borrado: false
            }
        },
        methods: {
            async getLevels(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',                    
                    table: 'levels',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.levels = response.data
                    }
                })
            },
            async getUser(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'select',
                    fields: ['user','pass', 'level_id', 'name'],
                    where: ' id = ' + this.id ,
                    table: 'users',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.form = response.data
                        this.passOld = response.data.pass
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 100);
                })
            },
            async getProject(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'SELECT',
                    fields: ['id', 'project_id'],
                    where: ' user_id = ' + this.id,
                    table: 'users_projects',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.project =  response.data.map( (e)=>  {
                            return e.project_id
                        })
                        this.proyecto =  response.data
                        this.proyectoOld = response.data
                    }
                })
            },

            async getProjects(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: false,
                    method: 'select',
                    fields: ['id','proyecto'],
                    table: 'proyectos',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.proyectos = response.data
                    }else{
                        this.proyectos = []
                    }
                })
            },
            save() {
                this.$root.$emit('isConnect')  
                if(this.form.user  == ''){
                    this.$root.$emit('msgError','El campo Email es obligatorio')
                    this.error = true 
                    return false
                }else{
                    this.error = false
                }
                if(this.form.pass  == ''){
                    this.$root.$emit('msgError','El campo contraseña es obligatorio')
                    this.error = true
                    return false                     
                }else{
                    this.error = false
                }


                if(this.error == false){
                    if(this.passOld != this.form.pass){
                        this.form.pass = sha1(this.form.pass)
                    }
                    this.id > 0 ? this.update() : this.insert() ; 
                }

            },
            async insert(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'INSERT',
                    table: 'users',
                    form: this.form
                }).then(response => {
                    if(response.data != 'Algo ha fallado' && response.data != "El usuario ya existe"){
                        this.$root.$emit('msgSuccess', 'Registro insertado')
                        setTimeout(() => {
                            this.$router.push('/dashboard/usuarios');                        
                        }, 1000);
                    }else{
                        this.$root.$emit('msgError', response.data)
                    }
                })

            },
            async update(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'UPDATE',
                    id: this.id ,
                    table: 'users',
                    form: this.form
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.$root.$emit('msgSuccess', 'Registro actualizado')
                        setTimeout(() => {
                            this.$router.push('/dashboard/usuarios');                        
                        }, 1000);               
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            },
            addProject(){
                this.addNewProject = true
            },
            deleteProjectc(e){
                if(this.id){
                    this.borrado = e
                }
            },
            changueProjectc(e ){
                this.$root.$emit('isConnect')  
                setTimeout(() => {
                    if(this.id){
                        if(this.borrado == false){
                                ApiService.post("public/v1", {
                                    token: localStorage.getItem("analiticatoken"),
                                    single: true,
                                    method: 'INSERT',
                                    table: 'users_projects',
                                    form: {
                                        user_id: this.id,
                                        project_id: parseInt(e[e.length - 1])
                                    }
                                }).then( response => {
                                    this.$root.$emit('msgSuccess','Registro actualizado con éxito')
                                })
                        }else{
                            this.proyectoOld.filter( p => {
                                if(this.borrado == p.project_id) {
                                    ApiService.post("public/v1", {
                                        token: localStorage.getItem("analiticatoken"),
                                        single: true,
                                        method: 'DELETE',
                                        id: p.id,
                                        table: 'users_projects',
                                    }).then( response => {
                                        this.$root.$emit('msgSuccess', 'Registro actualizado con éxito')
                                    })
                                    this.borrado = false
                                }
                            })
                        }
                        
                    }                    
                }, 500);
            },
            close(){
                this.$root.$emit('isConnect')                
                this.$router.push('/dashboard/usuarios')
            }
         }
    }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/forms/usuario.vue